export const SET_SUBCATEGORIES_MARKETPLACE_PRODUCTS = "SET_SUBCATEGORIES_MARKETPLACE_PRODUCTS";
export const SET_CATEGORIES_MARKETPLACE_PRODUCTS = "SET_CATEGORIES_MARKETPLACE_PRODUCTS";
export const SET_COMPANIES_LIST_TYPE_DOCUMENT = "SET_COMPANIES_LIST_TYPE_DOCUMENT";
export const SET_ALL_MONETIZATION_TYPES = "SET_ALL_MONETIZATION_TYPES";
export const SET_COMPANIES_BY_ID = "SET_COMPANIES_BY_ID";
export const SET_FUNCTIONALITIES = "SET_FUNCTIONALITIES";
export const SET_COMPANIES = "SET_COMPANIES";
export const SET_COMPANY_DEMO_TYPES = "SET_COMPANY_DEMO_TYPES";